/**
 * O pedido de pesquisa que a aba Clientes manda abrir na ficha — 17/09/2026.
 *
 * ⚠️ Sem pôr nada na barra de endereço: o identificador do pedido não fica no
 * histórico do navegador. Guardado na aba, lido UMA vez pela ficha.
 */
const CHAVE = 'kairos-abrir-pedido';

export function pedirParaAbrirNaFicha(pedidoId: string, clienteId: string): void {
  try {
    sessionStorage.setItem(CHAVE, JSON.stringify({ pedidoId, clienteId }));
  } catch {
    /* sem armazenamento: a ficha abre, e o pedido está no painel */
  }
}

/**
 * ⛔ Só na ficha do MESMO cliente, e uma vez: se a ficha dele falhou ao abrir, o
 * pedido não pode aparecer sozinho na ficha do próximo cliente aberto (talvez
 * em reunião), com os investigados de outro.
 */
export function pedidoParaAbrir(clienteId: string): string | null {
  try {
    const v = JSON.parse(sessionStorage.getItem(CHAVE) ?? 'null') as { pedidoId?: string; clienteId?: string } | null;
    sessionStorage.removeItem(CHAVE);
    return v?.clienteId === clienteId && v.pedidoId ? v.pedidoId : null;
  } catch {
    return null;
  }
}
